import React, { Component } from "react";
import Content from "../../content/Content";
import SmartLink from "./links/SmartLink";
import Media from "react-media";
import { Breakpoints } from "../../constants/CssConstants";
import style from "../../assets/css/modules/shared/promo-image-card.css";
import Store from "../../content/Store";
// import Button from "../../components/shared/buttons/Button";
import StyledButton from "./buttons/StyledButton";
import { Urls } from "../../constants/UrlConstants";
import { Layouts,ButtonConfig } from "../../constants/Constants";
import { SendPolicyNumberToHBS } from "../../services/HbsService";

const mobileWidth ={
  width:'100%' 
} ;

export class PromoImageCard extends Component {
  async onMakeAnAppointmentButton(membershipnumber) {    
    try{
      const newTab = window.open(Urls.AxaMakeAnAppointmentButton, "_blank");
      const response = await SendPolicyNumberToHBS(membershipnumber);
      console.log(response.data);
      newTab.location.href = response.data;
    }
    catch
    {
      window.open(Urls.AxaMakeAnAppointmentButton, "_blank");
    }
  }
  GetMatchedImage(matches, imgSrcMobile, imgSrc) {
    return matches ? (
      <img src={imgSrcMobile} alt="" aria-hidden style={mobileWidth}  />
    ) : (
      <img src={imgSrc} alt="" aria-hidden />
    );
  }

  render() {
    let textContent = (
      <div className={`
      ${this.props.UniqueKey==="AppointmentSection" ?style.leftSection:style.wrapper} ${this.props.IsNuffieldGym ? style.nuffieldgymcontent : ""
        }
    `}>
        {this.props.Banner ? (
          <div className={style.banner}>
            <Content name={this.props.Banner} />
          </div>
        ) : null}
        <h2 className={`${this.props.UniqueKey==="AppointmentSection" ?style.AppointmentHeading:style.heading}`}>
          <Content name={this.props.Heading} />
        </h2>
        {this.props.HealthSupportScroll !== true ? 
        <p>
          <Content name={this.props.Description} /> </p> :
          <p>
          <Content name={this.props.Description1} />
          <a href='/247healthsupportline' onClick={(e) =>  {e.preventDefault(); this.props.scrollSmoothHandler(e);}}> 
          <Content name={this.props.Description2} /> </a>
          <Content name={this.props.Description3} />
          </p>
          }
        {this.props.UniqueButton === "AppointmentButton" ?
          <StyledButton
            id={ButtonConfig.MskMakeAppointment}
            buttonType={this.props.layout === Layouts.MOL ? "primaryBlueButton" : "secondaryOrangeButtonSupportDCA"}
            label={Store.WorkingBody.ButtonLeftLabel}
            Healthsupportline1="Healthsupportline"
            onClick={() => this.onMakeAnAppointmentButton(this.props.membershipNumber)}
            layout={this.props.layout}
            buttonColor='blue'   
          /> : " "
        }
        {this.props.scrollProperty !==  true ? 
        <SmartLink
          UniqueKey ={this.props.UniqueKey }
          to={this.props.LinkTo}
          className={  
            // this.props.Layout === Layouts.MOL ? 
            this.props.UniqueKey === "mskBanner"?
            this.props.Layout === Layouts.MOL ? 
            style.MSKBanner:this.props.Layout === Layouts.HOL?style.MSKBannerHOL:" ":style.cardLink 
          // style.MSKBanner:"":this.props.Layout === Layouts.HOL?style.MSKBannerHOL:" "   
            }
          isExternalLink={this.props.IsExternalLink}
          aria-label={this.props["aria-label"]}
          accessPage={this.props.accessPage}
        >
          <Content name={this.props.LinkText} />
          {this.props.promoImageCardSupport === "promoImageCardSupport" ? "": <span className="ml-2">➔</span>}
        </SmartLink>
        :
        <a href='/healthstore' onClick={(e) =>  {e.preventDefault(); this.props.scrollSmoothHandler(e);}}  className={style.cardLink}
        aria-label={this.props["aria-label"]}> 
        <Content name={this.props.LinkText} /></a>
  }
      </div>
    );
    let imgContent = (
      <div className={style.imageBg}>
        <Content
          names={[
            this.props.ImgSrc,
            this.props.ImgSrcMobile,
            this.props.Heading
          ]}
        >
          {(imgSrc, imgSrcMobile, altText) => (
            <Media query={Breakpoints.smDown}>
              {(matches) => this.GetMatchedImage(matches, imgSrcMobile, imgSrc)}
            </Media>
          )}
        </Content>
      </div>
    );
    return (
      <div
        className={`
        ${this.props.UniqueKey==="AppointmentSection" ?style.AppointmentPromoImageCard:style.promoImageCard} ${this.props.promoImageCardSupport ? style.promoImageCardSupport : null} ${this.props.Banner ? style.healthStore : null
          }
        `}
      >
        {!!this.props.LeftImage ? (
          <React.Fragment>
            {imgContent}
            {textContent}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {textContent}
            {imgContent}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default PromoImageCard;
